module.exports = __webpack_public_path__ + "img/5_3.d48ed1de.png";